import React from 'react';
import {BackDropCMS} from '../../../../components/backdrop/backdrop_cms';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Checkbox,
    FormControlLabel,
    Typography,
    withStyles,
} from 'material-ui';
import {styles} from '../../style/url_popup';

//TODO to refactor the contents of this function

const UrlPopup = ({
    onUrlChange,
    onNoIndexChange,
    classes,
    open,
    url,
    urlValid,
    noindex,
    onHandleSubmit,
    onHandleClose,
}) => {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth={false}
            classes={{
                paper: classes.paperDialog,
                fullWidth: classes.fullWidth,
            }}
            BackdropComponent={BackDropCMS}
        >
            <DialogTitle>Edit Url</DialogTitle>
            <DialogContent>
                {urlValid ? (
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUrlChange(event.target.value);
                        }}
                        fullWidth
                        value={url}
                    />
                ) : (
                    <TextField
                        error
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUrlChange(event.target.value);
                        }}
                        fullWidth
                        value={url}
                    />
                )}

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!noindex}
                            onChange={(event, checked) => {
                                onNoIndexChange(checked);
                            }}
                        />
                    }
                    label="no-index"
                />
                <Typography
                    variant="caption"
                    color="error"
                    className={classes.mandatoryText}
                >
                    <b>Warning!</b>
                    <br />
                    no-indexing this page means that the page won't be crawled
                    and therefore won't be indexed by search engines.
                    <br />
                    This can potentially damage SEO, please be 100% sure before
                    no-indexing this page!
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActionsBtn}>
                <Button variant="raised" onClick={(ev) => onHandleClose(ev)}>
                    Cancel
                </Button>
                <Button
                    variant="raised"
                    onClick={(ev) => onHandleSubmit(ev)}
                    color="primary"
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(UrlPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/url_popup.js